import React, { useMemo } from 'react';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { useYesNoDataGridFilter } from '../../../../common/DataGrid/filters/DataGridFilters.jsx';
import {
  dataGridNumberSorter,
  dataGridTextSorter,
} from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import PropTypes from 'prop-types';
import Spinner from '../../../../common/spinner/Spinner.jsx';
import { useTranslation } from 'react-i18next';

const PollsTable = ({ polls, onEdit, customSettings, optionsWidth }) => {
  const { t } = useTranslation();

  const nameTextFilterProps = useDataGridTextFilter('name');
  const activeBooleanFilterProps = useYesNoDataGridFilter('active');

  const dataGridColumns = useMemo(
    () => [
      {
        title: t('Názov ankety'),
        dataIndex: 'name',
        ellipsis: true,
        sorter: dataGridTextSorter('name'),
        defaultSortOrder: 'ascend',
        ...nameTextFilterProps,
      },
      {
        title: t('Počet otázok'),
        dataIndex: 'questionsCount',
        sorter: dataGridNumberSorter('questionsCount'),
      },
      {
        title: t('Počet odpovedí'),
        dataIndex: 'noOfResponses',
        sorter: dataGridNumberSorter('noOfResponses'),
      },
      {
        title: t('Aktívna'),
        dataIndex: 'active',
        ...activeBooleanFilterProps,
      },
    ],
    [t, nameTextFilterProps, activeBooleanFilterProps],
  );

  if (!polls) {
    return <Spinner />;
  }

  return (
    <>
      <DataGrid
        rowKey={(poll) => poll.id}
        columns={dataGridColumns}
        dataSource={polls || []}
        permissionsBasic={'polls'}
        uniqueTableId={'polls-table'}
        onRowClick={onEdit}
        customSettings={customSettings}
        optionsWidth={optionsWidth}
      />
    </>
  );
};

PollsTable.propTypes = {
  polls: PropTypes.any,
  customSettings: PropTypes.any,
  onCreateClick: PropTypes.func,
  onEdit: PropTypes.func,
};

export default PollsTable;
